export default {
    branches: state => state.branches,
    branchSelected: state => state.branchSelected,
    askForLocation: state => state.askForLocation,
    selectBranchModal: state => state.selectBranchModal,
}